import React from 'react';
import {
  BannerWrapper,
  LeftSection,
  ContentSection,
  Subtitle,
  RightSection,
  BannerRoot,
} from './styled';
import ChevronLeftIcon from 'assets/svg/chevron-left.svg';
import CheckmarkIcon from 'assets/svg/checkmark-circle-brand.svg';
import { Text } from 'ds/components/typography';

export interface NotificationBannerProps {
  type: 'success';
  title: string;
  subtitle?: string;
  onActionClick?: () => void;
}

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
  type,
  title,
  subtitle,
  onActionClick,
}) => {
  const hasAction = !!onActionClick;

  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick();
    }
  };

  return (
    <BannerRoot>
      <BannerWrapper>
        {type === 'success' ? (
          <RightSection>
            <CheckmarkIcon />
          </RightSection>
        ) : null}
        <ContentSection>
          <Text weight="bold">{title}</Text>
          {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        </ContentSection>
        {onActionClick ? (
          <LeftSection
            clickable={hasAction}
            onClick={handleActionClick}
          >
            <ChevronLeftIcon width={20} height={32} />
          </LeftSection>
        ) : null}
      </BannerWrapper>
    </BannerRoot>
  );
};
